import { useCallback } from "react";
import { useDispatch } from "react-redux";

import store from "@/redux/store";
import useFilterStore from "@/stores/useFilterStore";
import { APPEND_USER_ESTATE_ACCESS, UPDATE_FILTER } from "@/redux/types/auth.types";
import { collectEstateIdsForParent, mergeCommaSeparatedIds } from "@/utils/estateFilterAccess";

export function useApplyCreatedEstateAccess() {
	const dispatch = useDispatch();

	const applyCreatedEstateAccess = useCallback(
		({ estateParent, estates }) => {
			const estateParentPayload = estateParent
				? {
						...estateParent,
						show_estate: true,
					}
				: null;

			dispatch({
				type: APPEND_USER_ESTATE_ACCESS,
				payload: { estateParent: estateParentPayload, estates },
			});

			const state = store.getState();
			const currentFilter = state.auth?.filter ?? {};
			const userEstates = state.auth?.user?.estates ?? [];
			const parentValue = estateParent ? Number(estateParent.value ?? estateParent.id) : null;

			const estateParentId = estateParent ? mergeCommaSeparatedIds(currentFilter.estate_parent_id, parentValue) : currentFilter.estate_parent_id;

			const estateIdsForFilter = parentValue
				? collectEstateIdsForParent({
						estateParentId: parentValue,
						estateIds: estates,
						userEstates,
					})
				: collectEstateIdsForParent({ estateIds: estates, userEstates });

			const estateId = estateIdsForFilter.length > 0 ? mergeCommaSeparatedIds(currentFilter.estate_id, ...estateIdsForFilter) : currentFilter.estate_id;

			const nextFilter = {
				...currentFilter,
				estate_parent_id: estateParentId ?? "",
				estate_id: estateId ?? "",
			};

			dispatch({
				type: UPDATE_FILTER,
				payload: { filter: nextFilter },
			});

			useFilterStore.getState().setFilter(nextFilter);
		},
		[dispatch],
	);

	return { applyCreatedEstateAccess };
}
